// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__h9rxU","container":"styles_container__0A-Af","content":"styles_content__H2fjz","title":"styles_title__tnpC1","description":"styles_description__9ur7i"};